/** @jsxImportSource @emotion/react */

import { FC, Ref, ReactNode } from "react";
import { css } from "@emotion/react";
import "@rmwc/switch/styles";
import { Switch } from "@rmwc/switch";
import Text from "../../DataDisplay/Text";

export type SwitchesProps = {
  checked?: undefined | false | true;
  disabled?: undefined | false | true;
  foundationRef?: Ref<any>;
  id?: string | undefined;
  inputRef?: Ref<HTMLInputElement>;
  label?: ReactNode;
  value?: string | number | string[] | boolean;
  tag?: any;
  onChange?: Function;
  required?: boolean;
  className?: string;
};

const Switches: FC<SwitchesProps> = (props) => {
  const {
    checked,
    disabled,
    value,
    foundationRef,
    id,
    inputRef,
    label,
    tag,
    onChange,
    required = false,
    className,
  } = props;

  return (
    <div
      className={className}
      css={css`
        margin: 0 5px;
      `}
    >
      <Switch
        id={id}
        checked={checked}
        disabled={disabled}
        value={value}
        foundationRef={foundationRef}
        inputRef={inputRef}
        label={<Text type={"paragraph"}>{label}</Text>}
        tag={tag}
        onChange={onChange}
        required={required}
      />
    </div>
  );
};

export default Switches;
